<div class="content-wrapper">
	<activity-task-overview></activity-task-overview>
	<activity-task-pane
		(taskSelected)="onTaskSelected($event)"
		[inMobilePanel]="true"
		[isEditMode]="isEditMode">
	</activity-task-pane>
</div>
